//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/Annotations.js";
import "../no/Drawings.js";
import "../no/Part.js";
let d=[[],[[[],"CreateSnapshot",{},0,0],[[],"CreateTrackChanges",{},0,0],[[],"DeleteTrackChanges",{},0,0],[[],"DeleteSnapshot",{},0,0],[[],"DeleteComparisonReport",{},0,0],[["subfileID"],"GetEntityObjectFromId",{R_:{entity:"NXObject"}},1,0],[[],"CreateDrawingCompareSettingsBuilder",{R_:{builder:"Drawings.DrawingCompareSettingsBuilder"}},0,1],[["partFileNameToCompare","reuseExistingSnapshot"],"CreateCompareReportBuilder",{R_:{builder:"Drawings.CompareReportBuilder"}},2,0],[[],"CreateOverlayData",{},0,0],[[],"DeleteOverlayData",{},0,0],[["idSymbols"],"PreserveChangeSymbol",{},1,0],[["idSymbols"],"UnpreserveChangeSymbol",{},1,0],[["removeUndoMarks"],"SetRemoveUndoMarks",{},1,0]],[]];
SPLM.DrawingCompareManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.DrawingCompareManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;